import {toInt, toISODate, toDecimal, formatDateBr, toBigNumber, normalizeDecimalInput} from "../../../../utils/convert-fields"

export const eventosOrdinariosDecimalFields = {
    ValorNominal: "Valor Nominal",
    IndexadorCorrecaoPercentual: "Indexador Correção Percentual",
    AmortizacaoOrdinariaPercentual: "Amortização Ordinária Percentual",
    TaxaJuros: "Taxa Juros",
    JurosIncorporacaoProgramadaPercentual: "Juros Incorporação Programada Percentual",
}

const decimalField = (column, field, line) => {
    try {
        return normalizeDecimalInput(column[field])
    } catch (_error) {
        throw new Error(`Linha ${line}: valor inválido em ${eventosOrdinariosDecimalFields[field]}.`)
    }
}

const normalizeObservacao = (value) => {
    const text = value == null ? "" : String(value).trim()
    return text || null
}

export const periodicidadeReverseMap = {
        "Diária": 1,
        "Mensal": 2,
        "Trimestral": 3,
        "Semestral": 4,
        "Anual": 5,
        "Não tem": 6,
}

export const mapEventosOrdinariosPayload = (tableData = []) => {

    const eventosOrdinarios = tableData
        .filter(column =>
            column &&
            Object.keys(column).length > 0 &&
            Object.values(column).some(v => v !== "" && v !== null && v !== undefined)
        )
        .map((column, index) => ({
            IDFluxoEvento: toInt(column.IDFluxoEvento) ?? null,
            DataReferencia: toISODate(column.DataReferencia),
            Indexador: column.Indexador || null,
            ValorNominal: toDecimal(decimalField(column, "ValorNominal", index + 1)) ?? null,
            LiquidezDiaria: toInt(column.LiquidezDiaria) ?? null,
            IndexadorCorrecaoPercentual: toDecimal(decimalField(column, "IndexadorCorrecaoPercentual", index + 1)) ?? null,
            Defasagem: toInt(column.Defasagem) ?? null,
            FormulaIndexador: toInt(column.FormulaIndexador) || null,
            PeriodicidadeAtualizacaoMonetaria:
                periodicidadeReverseMap[column.PeriodicidadeAtualizacaoMonetaria] ??
                toInt(column.PeriodicidadeAtualizacaoMonetaria) ??
                null,
            MesAniversarioAnualSemestral: column.MesAniversarioAnualSemestral || null,
            ProjecaoInflacao: toInt(column.ProjecaoInflacao) ?? null,
            InflacaoNegativa: toInt(column.InflacaoNegativa) ?? null,
            RecalculoProjecao: toInt(column.RecalculoProjecao) ?? null,
            DataEvento: toISODate(column.DataEvento),
            DataEventoEfetiva: toISODate(column.DataEventoEfetiva),
            DataAniversarioJuros: toISODate(column.DataAniversarioJuros),
            DataLiquidacao: toISODate(column.DataLiquidacao),
            AplicacaoAmortizacao: column.AplicacaoAmortizacao || null,
            AmortizacaoOrdinariaPercentual: toBigNumber(decimalField(column, "AmortizacaoOrdinariaPercentual", index + 1)) ?? null,
            TaxaJuros: toDecimal(decimalField(column, "TaxaJuros", index + 1)) ?? null,
            JurosCapitalizacao: toInt(column.JurosCapitalizacao) ?? null,
            JurosIncorporacaoProgramadaPercentual: toBigNumber(decimalField(column, "JurosIncorporacaoProgramadaPercentual", index + 1)) ?? null,
            DataRentabilidadeInicio: toISODate(column.DataRentabilidadeInicio),
            DataRentabilidadeFim: toISODate(column.DataRentabilidadeFim),
            CalculoFatorJuros: column.CalculoFatorJuros || null,
            CasasFatorJuros: toInt(column.CasasFatorJuros) ?? null,
            CalculoJuros: column.CalculoJuros || null,
            CasasJuros: toInt(column.CasasJuros) ?? null,
            CalculoFatorCorrecao: column.CalculoFatorCorrecao || null,
            CasasFatorCorrecao: toInt(column.CasasFatorCorrecao) ?? null,
            CalculoCorrecao: column.CalculoCorrecao || null,
            CasasCorrecao: toInt(column.CasasCorrecao) ?? null,
            CalculoFatorJurosCDI: column.CalculoFatorJurosCDI || null,
            CasasFatorJurosCDI: toInt(column.CasasFatorJurosCDI) ?? null,
            CalculoVNA: column.CalculoVNA || null,
            CasasVNA: toInt(column.CasasVNA) ?? null,
            CalculoFatorDesconto: column.CalculoFatorDesconto || null,
            CasasFatorDesconto: toInt(column.CasasFatorDesconto) ?? null,
            CalculoFatorExpectativa: column.CalculoFatorExpectativa || null,
            CasasFatorExpectativa: toInt(column.CasasFatorExpectativa) ?? null,
            CalculoPU: column.CalculoPU || null,
            CasasPU: toInt(column.CasasPU) ?? null,
            Observacao: normalizeObservacao(column.Observacao),
        }))

    return {
        EventosOrdinarios: eventosOrdinarios,
    }
}

const periodicidadeMap = {
    1: "Diária",
    2: "Mensal",
    3: "Trimestral",
    4: "Semestral",
    5: "Anual",
    6: "Não tem"
}


export const mapEventosOrdinariosToTable = (apiData = [], cetip, versaoDocumento, IDEmissao) => {
    if (!apiData || apiData.length === 0) return [{}]

    return apiData.map(item => ({
        IDFluxoEvento: item.IDFluxoEvento ?? "",
        IDEmissao: IDEmissao ?? item.IDEmissao ?? "",
        VersaoDocumento: versaoDocumento ?? item.VersaoDocumento ?? "",
        DataReferencia: formatDateBr(item.DataReferencia),
        CETIP: cetip ?? item.CETIP ?? "",
        Indexador: item.Indexador || "",
        ValorNominal: item.ValorNominal ?? "",
        LiquidezDiaria: item.LiquidezDiaria ?? null,
        IndexadorCorrecaoPercentual: item.IndexadorCorrecaoPercentual ?? "",
        Defasagem: item.Defasagem ?? null,
        CalculoDiasIndexador: item.CalculoDiasIndexador || "",
        FormulaIndexador: item.FormulaIndexador ?? null,
        PeriodicidadeAtualizacaoMonetaria:
            periodicidadeMap[item.PeriodicidadeAtualizacaoMonetaria] ??
            item.PeriodicidadeAtualizacaoMonetaria ??
            "",
        MesAniversarioAnualSemestral: item.MesAniversarioAnualSemestral || null,
        ProjecaoInflacao: item.ProjecaoInflacao ?? null,
        InflacaoNegativa: item.InflacaoNegativa ?? null,
        RecalculoProjecao: item.RecalculoProjecao ?? null,
        DataEvento: formatDateBr(item.DataEvento),
        DataEventoEfetiva: formatDateBr(item.DataEventoEfetiva),
        DataAniversarioJuros: formatDateBr(item.DataAniversarioJuros),
        DataLiquidacao: formatDateBr(item.DataLiquidacao),
        AplicacaoAmortizacao: item.AplicacaoAmortizacao || "",
        AmortizacaoOrdinariaPercentual: item.AmortizacaoOrdinariaPercentual ?? "",
        TaxaJuros: item.TaxaJuros ?? "",
        CalculoDias: item.CalculoDias || "",
        JurosCapitalizacao: item.JurosCapitalizacao ?? null,
        JurosIncorporacaoProgramadaPercentual: item.JurosIncorporacaoProgramadaPercentual ?? "",
        DataRentabilidadeInicio: formatDateBr(item.DataRentabilidadeInicio),
        DataRentabilidadeFim: formatDateBr(item.DataRentabilidadeFim),
        CalculoFatorJuros: item.CalculoFatorJuros || "",
        CasasFatorJuros: item.CasasFatorJuros ?? null,
        CalculoJuros: item.CalculoJuros || "",
        CasasJuros: item.CasasJuros ?? null,
        CalculoFatorCorrecao: item.CalculoFatorCorrecao || "",
        CasasFatorCorrecao: item.CasasFatorCorrecao ?? null,
        CalculoCorrecao: item.CalculoCorrecao || "",
        CasasCorrecao: item.CasasCorrecao ?? null,
        CalculoFatorJurosCDI: item.CalculoFatorJurosCDI || "",
        CasasFatorJurosCDI: item.CasasFatorJurosCDI ?? null,
        CalculoVNA: item.CalculoVNA || "",
        CasasVNA: item.CasasVNA ?? null,
        CalculoFatorDesconto: item.CalculoFatorDesconto || "",
        CasasFatorDesconto: item.CasasFatorDesconto ?? null,
        CalculoFatorExpectativa: item.CalculoFatorExpectativa || "",
        CasasFatorExpectativa: item.CasasFatorExpectativa ?? null,
        CalculoPU: item.CalculoPU || "",
        CasasPU: item.CasasPU ?? null,
        Observacao: item.Observacao ?? "",
    }))
}